import styled from 'styled-components';

export const AdminSidebarContainer = styled.div<{ $collapsed: boolean; $isMobileOpen?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: ${props => props.$collapsed ? '80px' : '280px'};
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  transition: all 0.3s ease;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  transform: translateX(0);

  @media (max-width: 768px) {
    width: 280px;
    transform: translateX(${props => props.$isMobileOpen ? '0' : '-100%'});
    z-index: 999;
  }
`;

export const AdminSidebarHeader = styled.div`
  padding: 24px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AdminSidebarLogo = styled.div<{ $collapsed: boolean }>`
  font-size: ${props => props.$collapsed ? '24px' : '20px'};
  font-weight: 700;
  color: white;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
`;

export const AdminSidebarNav = styled.nav`
  flex: 1;
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AdminSidebarItem = styled.div<{ $active: boolean; $collapsed: boolean }>`
  display: flex;
  align-items: center;
  padding: 12px 20px;
  margin: 0 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${props => props.$active ? 'rgba(240, 147, 251, 0.2)' : 'transparent'};
  border: ${props => props.$active ? '1px solid rgba(240, 147, 251, 0.3)' : '1px solid transparent'};
  min-height: 48px; /* Touch-friendly minimum height */
  
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    transform: translateX(2px);
  }

  &:active {
    transform: translateX(2px) scale(0.98);
    background-color: rgba(255, 255, 255, 0.15);
  }
  
  ${props => props.$collapsed && `
    justify-content: center;
    padding: 12px;
  `}

  @media (max-width: 768px) {
    padding: 16px 20px;
    margin: 0 8px;
    min-height: 56px; /* Larger touch targets on mobile */
  }
`;

export const AdminSidebarIcon = styled.span`
  font-size: 20px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
`;

export const AdminSidebarLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
`;

export const AdminSidebarFooter = styled.div`
  margin-top: auto;
  padding: 20px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

// Note: Responsive design handled via CSS media queries in global styles
